import apiClient, { setAuthToken } from '../utils/apiClient';
import type { LoginResponse, User } from '../types/auth';

export type AdminFeatures = {
  email_otp_enabled: boolean;
  user_management_visible: boolean;
};

class AuthService {
  async getConfig(): Promise<AdminFeatures> {
    const response = await apiClient.get<AdminFeatures>('/api/admin/auth/config');
    return response.data;
  }

  async loginPassword(email: string, password: string): Promise<LoginResponse> {
    const response = await apiClient.post<LoginResponse>('/api/admin/auth/password', { email, password });
    this.save(response.data);
    return response.data;
  }

  async startEmail(email: string, password: string): Promise<string> {
    const response = await apiClient.post<{ challenge: string }>('/api/admin/auth/email/start', { email, password });
    return response.data.challenge;
  }

  async verifyEmail(challenge: string, code: string): Promise<LoginResponse> {
    const response = await apiClient.post<LoginResponse>('/api/admin/auth/email/verify', { challenge, code });
    this.save(response.data);
    return response.data;
  }

  private save(response: LoginResponse): void {
    if (!response.success || !response.token || !response.user) throw new Error('ログインに失敗しました');
    setAuthToken(response.token);
  }

  async logout(): Promise<void> {
    try { await apiClient.post('/api/admin/auth/logout'); }
    finally { setAuthToken(null); }
  }

  async getCurrentUser(): Promise<User | null> {
    if (!this.isAuthenticated()) return null;
    try {
      const response = await apiClient.get<{ success: boolean; data: User }>('/api/admin/auth/me');
      return response.data.data;
    } catch {
      setAuthToken(null);
      return null;
    }
  }

  isAuthenticated(): boolean { return !!sessionStorage.getItem('mederi_admin_auth_token'); }
}

export const authService = new AuthService();
export default authService;
